<template>
  <div class="unitOfMeasureItemComponentForm">
    <v-form ref="form1" v-model="valid1" lazy-validation>
      <v-layout row>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            :disabled="ID !== 0"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Početak"
              readonly
              @blur="date = parseDate(dateFormatted)"
              :disabled="ID !== 0"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="ID !== 0"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label=""
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="ID !== 0"
            ></v-text-field>
            <v-time-picker
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
              clearable
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menuTo"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            :disabled="ID > 0 && !izmena"
          >
            <v-text-field
              slot="activator"
              v-model="dateToFormatted"
              label="Završetak"
              readonly
              @blur="dateTo = parseDate(dateToFormatted)"
              :disabled="ID > 0 && !izmena"
              @click:clear="brisanjeZavrsetka"
              clearable
            ></v-text-field>
            <v-date-picker
              v-model="dateTo"
              no-title
              @input="menuTo = false"
              :max="maxDate"
              v-on:change="postaviVremeDo"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-menu
            ref="menu2"
            :close-on-content-click="false"
            v-model="menu2"
            :nudge-right="0"
            :return-value.sync="timeZavrsetka"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
          >
            <v-text-field
              slot="activator"
              v-model="timeZavrsetka"
              label=""
              readonly
            ></v-text-field>
            <v-time-picker
              v-model="timeZavrsetka"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu2.save(timeZavrsetka)"
              clearable
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu2.save(timeZavrsetka)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs2 pa-2> </v-flex>
        <v-flex xs3 pa-2>
          <v-autocomplete
            v-model="pheno_phase_select"
            :items="pheno_phase_items"
            item-text="name"
            item-value="id"
            label="Feno faza"
            persistent-hint
            return-object
            ref="element5"
            :disabled="ID > 0 && !izmena"
          ></v-autocomplete>
        </v-flex>
        <v-flex
          xs1
          pa-2
          style="
            padding-top: 20px !important;
            padding-left: 0px !important;
            padding-top: 20px !important;
            max-width: 40px !important;
          "
        >
          <v-icon
            slot="activator"
            @click="otvoriSifarnik"
            style="color: #018389; padding-left: 0px; font-weight: bold"
            title="Dodavanje feno faze"
            v-if="ID >= 0 && izmena"
            >add</v-icon
          >
        </v-flex>
      </v-layout>
    </v-form>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row>
        <v-flex xs12 pa-2>
          <v-text-field
            v-model="opis_zasada"
            label="Opis"
            :disabled="ID > 0 && !izmena"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-btn @click="submit" class="AppButtonFilled" :disabled="!izmena"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined" v-if="izmena"
            >odustani</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            :disabled="!izmena"
            v-else
            style="border: none !important"
            >odustani</v-btn
          >
        </v-flex>
        <v-flex xs3> </v-flex>

        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_sorti !== 0">
            <p class="gornji_text" v-html="broj_sorti"></p>
            <p class="donji_text" v-html="formatTekstaSorta2(broj_sorti)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">sorti</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_redova !== 0">
            <p class="gornji_text" v-html="broj_redova"></p>
            <p class="donji_text" v-html="formatTekstaRed2(broj_redova)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">redova</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_kalemova !== 0">
            <p class="gornji_text" v-html="broj_kalemova"></p>
            <p
              class="donji_text"
              v-html="formatTekstaKalem2(broj_kalemova)"
            ></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text"
            v-html="formatTekstaKalem2(0)"></p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <template v-if="povrsina > 1000">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p
                class="gornji_text"
                v-html="Math.round(povrsina / 100) / 100"
              ></p>
              <p class="donji_text">ha</p>
            </div>
          </template>
          <template v-else-if="povrsina > 0">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p class="gornji_text" v-html="Math.round(povrsina) / 100"></p>
              <p class="donji_text">ar</p>
            </div>
          </template>
          <template v-else>
            <div class="div_prozorce">
              <p class="gornji_text">-</p>
              <p class="donji_text">ar</p>
            </div>
          </template>
        </v-flex>
        <v-flex
          xs1
          pa-2
          v-if="ID > 0"
          style="
            text-align: right !important;
            padding-right: 20px !important;
            padding-top: 5px !important;
          "
        >
          <v-icon
            slot="activator"
            id="FloatingButton"
            @click="otvoriModal_izabrani_redova"
            title="Dodavanje redova"
          ></v-icon>
        </v-flex>
      </v-layout>

      <!-- </v-container> -->
    </v-form>

    <v-dialog
      v-model="dialogNote_izabrani_redovi"
      scrollable
      content-class="ModalInModalVineyardRows"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentVineYardRows
              @newdata="handleDataVineyardRows($event)"
              @close="handleDataCloseVineyardRows($event)"
              :vineyardId="id_vineyard_pom"
              :ID="ID"
              :plaintObject="objVineyardPlaintPom"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :datumOperacije="datum_operacije"
              :izmena="izmena"
            ></MyComponentVineYardRows>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <PhenoPhase
              @close="handleDataCloseOperacije($event)"
              operationType="maka"
            ></PhenoPhase>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_message"
      scrollable
      content-class="ModalAlert"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentAlert
              @newdata="handleDataAlert($event)"
              @close="handleDataAlertClose($event)"
              :text="text_poruke"
              :question="alert_question"
            ></MyComponentAlert>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";

import MyComponentVineYardRows from "./VineyardOperationVineYardRowsComponent.vue";
import MyComponentAlert from "../helpers/Alert.vue";

import PhenoPhase from "../views/PhenoPhase.vue";

export default {
  name: "VineYardConditionComponent",
  components: {
    TokenComponent,
    MyComponentVineYardRows,
    MyComponentAlert,
    PhenoPhase,
  },
  data: () => ({
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000,
    },

    search: "",

    valid: true,
    valid1: true,
    ID: 0,
    ID_grape_variety: 0,
    ID_reda: 0,
    redni_broj: "",
    povrsina: 0,
    opis: "",
    opis_zasada: "",
    tip_zemljista: "",

    polozaj: "",
    sastav_tla: "",
    distanceBetweenRows: undefined,
    dateFormatted: null,
    menu: "",
    time: undefined,
    date: null,
    menuModal: "",
    menuModal2: "",
    dialogNote_izabrani_redovi: false,
    id_vineyard: 0,
    id_vineyard_block: 0,
    objVineyardPlaint: [],
    objVineyardOperationExecution: {},
    objVineyardOperationRows: [],
    izmena: false,
    od_cokota_red: undefined,
    broj_cokota_red: undefined,
    opis_red: undefined,
    naslov_izmena_reda: "",
    sufiks: "",
    pomFromNew: undefined,
    pomFromTo: undefined,
    prvi_prolaz: true,
    timeZavrsetka: undefined,
    menu1: "",
    menu2: "",
    pomFromNew2: undefined,
    objVineyardOperationBlock: [],
    objVineyardOperationTables: [],

    id_vineyard_pom: undefined,
    objVineyardOperationExecutionPom: {},
    /////////////////// Alerti //////////////////////////
    text_poruke: "",
    alert_question: false,
    dialogNote_message: false,
    /////////////////////////,

    broj_sorti: 0,
    broj_redova: 0,
    broj_kalemova: 0,

    datum_operacije: undefined,
    objVineyardPlaintPom: undefined,
    pheno_phase_select: undefined,
    pheno_phase_items: [],

    operacija: undefined,
    dialogNote_operacije: false,
    dateToFormatted: null,
    menuTo: "",
    dateTo: null,

    tekstBiljka: "",
    vinarija: true,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
    dateTo(val) {
      this.dateToFormatted = this.formatDate1(this.dateTo);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    postaviVremeDo(){
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.timeZavrsetka = [Hours, Minutes].join(":");
    },
    brisanjeZavrsetka() {
      this.timeZavrsetka = undefined;
    },
    getAllPhenoPhase(naziv) {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/pheno_phase", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.pheno_phase_items = response.data;

          if (naziv !== undefined && naziv !== null) {
            let index;

            index = this.pheno_phase_items.findIndex((x) => x.name === naziv);

            if (index >= 0)
              this.pheno_phase_select = this.pheno_phase_items[index];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/pheno_phase",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.pheno_phase_items = response.data;

                      if (naziv !== undefined && naziv !== null) {
                        let index;

                        index = this.pheno_phase_items.findIndex(
                          (x) => x.name === naziv
                        );

                        if (index >= 0)
                          this.pheno_phase_select =
                            this.pheno_phase_items[index];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    otvoriSifarnik(event) {
      this.operacija = "Feno faza";
      this.dialogNote_operacije = true;
    },
    handleDataCloseOperacije: function (e) {
      this.getAllPhenoPhase(e.name);
      this.dialogNote_operacije = false;
    },
    otvoriModal_izabrani_redova() {
      this.id_vineyard_pom = this.id_vineyard;
      this.objVineyardOperationExecutionPom =
        this.objVineyardOperationExecution;
      this.objVineyardPlaintPom = this.objVineyardPlaint;
      this.dialogNote_izabrani_redovi = true;
    },
    /////////////////////////// Alerti ///////////////////////
    handleDataAlert: function (e) {
      this.dialogNote_message = false;
    },
    handleDataAlertClose: function (e) {
      this.dialogNote_message = false;
    },
    //////////////////////////////////////////////////////////
    handleDataVineyardRows: function (e) {
      // this.dialogNote_izabrani_redovi = false;
    },
    handleDataCloseVineyardRows: function (e) {
      this.dialogNote_izabrani_redovi = false;
      this.objVineyardOperationRows = [];
      this.objVineyardPlaintPom = undefined;
      this.id_vineyard_pom = undefined;
      this.objVineyardOperationExecutionPom = undefined;

      if (this.ID > 0) {
        this.getAllSifarnikInit(this.ID);
        // this.clear();
      }

      // let pomObj;
      // let _this = this;

      // let rows = e.rows;
      // let blocks = e.blocks;

      // this.povrsina = 0;

      // rows.forEach(function (entry) {
      //   let lokID;

      //   lokID = entry.id_pom.split("_")[0];

      //   if (
      //     entry.vineyardOperationExecutionId !== undefined &&
      //     entry.vineyardOperationExecutionId !== null
      //   )
      //     pomObj = {
      //       executedNumberFrom: entry.executedNumberFrom,
      //       executedNumberTo: entry.executedNumberTo,
      //       id: entry.vineyardOperationExecutionId,
      //       vineyardRow: {
      //         id: lokID,
      //       },
      //       grapeVariety: {
      //         id: entry.grapeVarietyId,
      //       },
      //     };
      //   else
      //     pomObj = {
      //       executedNumberFrom: entry.executedNumberFrom,
      //       executedNumberTo: entry.executedNumberTo,
      //       vineyardRow: {
      //         id: lokID,
      //       },
      //       description: "",
      //       grapeVariety: {
      //         id: entry.grapeVarietyId,
      //       },
      //     };

      //   _this.objVineyardOperationRows.push(pomObj);

      //   _this.povrsina =
      //     _this.povrsina +
      //     Number(entry.distanceBetweenRows) *
      //       (entry.executedNumberTo - entry.executedNumberFrom + 1) *
      //       Number(entry.distanceBetweenPlants);
      // });

      // this.objVineyardOperationBlock = blocks;
      // this.objVineyardOperationExecution.surface = this.povrsina;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
      // this.dateTo = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    newSifarnik() {
      var complexObjectGroup;

      complexObjectGroup = {
        id: this.id_vineyard,
      };

      var complexObjectGlobal;
      if (this.objVineyardOperationBlock.length !== 0) {
        if (this.pheno_phase_select !== undefined && this.pheno_phase_select !== null)
          complexObjectGlobal = {
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            phenoPhase: {
              id: this.pheno_phase_select.id,
            },
            vineyardOperationBlocks: this.objVineyardOperationBlock,
            vineyardOperationTables: this.objVineyardOperationTables,
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.povrsina,
          };
        else
          complexObjectGlobal = {
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            vineyardOperationBlocks: this.objVineyardOperationBlock,
            vineyardOperationTables: this.objVineyardOperationTables,
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.povrsina,
          };
      } else {
        if (this.pheno_phase_select !== undefined && this.pheno_phase_select !== null)
          complexObjectGlobal = {
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            phenoPhase: {
              id: this.pheno_phase_select.id,
            },
            vineyardOperationBlocks: [],
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.povrsina,
          };
        else
          complexObjectGlobal = {
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            vineyardOperationBlocks: [],
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.povrsina,
          };
      }

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/create",
          complexObjectGlobal,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // this.clear();

          this.getAllSifarnikInit(response.data.id);

          this.ID = response.data.id;
          this.datum_operacije = this.date + "T" + this.time;

        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/create",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnikInit(response.data.id);

                      this.ID = response.data.id;
                      this.datum_operacije = this.date + "T" + this.time;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObjectGroup;

      complexObjectGroup = {
        id: this.id_vineyard,
      };

      var complexObjectGlobal;
      if (this.objVineyardOperationBlock.length !== 0) {
        if (this.pheno_phase_select !== undefined && this.pheno_phase_select !== null)
          complexObjectGlobal = {
            id: this.ID,
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            phenoPhase: {
              id: this.pheno_phase_select.id,
            },
            vineyardOperationBlocks: this.objVineyardOperationBlock,
            vineyardOperationTables: this.objVineyardOperationTables,
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.objVineyardOperationExecution.surface,
          };
        else
          complexObjectGlobal = {
            id: this.ID,
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            vineyardOperationBlocks: this.objVineyardOperationBlock,
            vineyardOperationTables: this.objVineyardOperationTables,
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.objVineyardOperationExecution.surface,
          };
      } else {
        if (this.pheno_phase_select !== undefined && this.pheno_phase_select !== null)
          complexObjectGlobal = {
            id: this.ID,
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            phenoPhase: {
              id: this.pheno_phase_select.id,
            },
            vineyardOperationBlocks: [],
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.objVineyardOperationExecution.surface,
          };
        else
          complexObjectGlobal = {
            id: this.ID,
            vineyard: complexObjectGroup,
            vineyardOperation: {
              id: 4,
            },
            vineyardOperationBlocks: [],
            vineyardOperationGrapeVarietys: [],
            vineyardOperationRows: this.objVineyardOperationRows,
            date: this.date + "T" + this.time,
            dateTo:
              this.dateTo !== undefined && this.dateTo !== null
                ? this.dateTo +
                  (this.timeZavrsetka !== undefined &&
                  this.timeZavrsetka !== null
                    ? "T" + this.timeZavrsetka
                    : "")
                : null,
            description: this.opis_zasada,
            surface: this.objVineyardOperationExecution.surface,
          };
      }

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/update",
          complexObjectGlobal,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear();

          this.getAllSifarnikInit(this.ID);

        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/update",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear();

                      this.getAllSifarnikInit(this.ID);

                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnikInit(idSadnje) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            idSadnje,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (this.id_vineyard === undefined)
            this.id_vineyard = response.data.vineyard.id;

          this.date = response.data.date.split("T")[0];
          this.time = this.formatTime(response.data.date.split("T")[1]);

          if (response.data.dateTo !== null) {
            this.dateTo = response.data.dateTo.split("T")[0];
            this.timeZavrsetka = this.formatTime(
              response.data.dateTo.split("T")[1]
            );
          } else this.dateTo = undefined;

          this.pheno_phase_select = response.data.phenoPhase;

          this.datum_operacije = this.date + "T" + this.time;

          this.opis_zasada = response.data.description;

          this.objVineyardPlaint = response.data;
          let _this = this;
          var counts = {};
          var rows = {};

          _this.broj_kalemova = 0;

          _this.objVineyardPlaint.vineyardOperationRows.forEach(function (e) {
            

            _this.broj_kalemova =
              _this.broj_kalemova +
              Number(e.executedNumberTo - e.executedNumberFrom + 1);

            counts[e.grapeVariety.id] = 1 + (counts[e.grapeVariety.id] || 0);

            rows[e.vineyardRow.id] = 1 + (rows[e.vineyardRow.id] || 0);
            // rows[e.id] = 1 + (rows[e.id] || 0);
          });

          _this.broj_sorti = Object.keys(counts).length;
          _this.broj_redova = Object.keys(rows).length;

          _this.povrsina =
            Math.round(_this.objVineyardPlaint.surface * 100) / 100;

          this.objVineyardOperationRows = response.data.vineyardOperationRows;

          this.objVineyardOperationBlock =
            response.data.vineyardOperationBlocks;

          this.objVineyardOperationTables =
            response.data.vineyardOperationTables;

          let pomObjVineyardOperationExecution = {
            id: null,
            vineyardOperation: {
              id: null,
            },
            vineyard: {
              id: null,
            },
            date: null,
            dateTo: null,
            vineyardOperationWorkForces: [],
            vineyardOperationMechanizations: [],
            vineyardOperationMaterials: [],
            vineyardOperationRows: response.data.vineyardOperationRows,
            description: null,
            phenoPhase: null,
            vineyardOperationBlocks: response.data.vineyardOperationBlocks,
            vineyardOperationTables: response.data.vineyardOperationTables,
          };

          pomObjVineyardOperationExecution.id = response.data.id;
          pomObjVineyardOperationExecution.vineyardOperation = {
            id: response.data.vineyardOperation.id,
          };
          pomObjVineyardOperationExecution.vineyard = {
            id: response.data.vineyard.id,
          };
          pomObjVineyardOperationExecution.date = response.data.date;
          pomObjVineyardOperationExecution.dateTo = response.data.dateTo;
          pomObjVineyardOperationExecution.surface = response.data.surface;
          pomObjVineyardOperationExecution.phenoPhase =
            response.data.phenoPhase;

          pomObjVineyardOperationExecution.description =
            response.data.description;

          this.objVineyardOperationExecution = {
            ...pomObjVineyardOperationExecution,
          };
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  if (this.id_vineyard === undefined)
                    this.id_vineyard = response.data.vineyard.id;

                  this.date = response.data.date.split("T")[0];
                  this.time = this.formatTime(response.data.date.split("T")[1]);

                  if (response.data.dateTo !== null) {
                    this.dateTo = response.data.dateTo.split("T")[0];
                    this.timeZavrsetka = this.formatTime(
                      response.data.dateTo.split("T")[1]
                    );
                  } else this.dateTo = undefined;

                  this.pheno_phase_select = response.data.phenoPhase;

                  this.datum_operacije = this.date + "T" + this.time;

                  this.opis_zasada = response.data.description;

                  this.objVineyardPlaint = response.data;
                  let _this = this;
                  var counts = {};
                  var rows = {};

                  _this.broj_kalemova = 0;

                  _this.objVineyardPlaint.vineyardOperationRows.forEach(
                    function (e) {
                      

                      _this.broj_kalemova =
                        _this.broj_kalemova +
                        Number(e.executedNumberTo - e.executedNumberFrom + 1);

                      counts[e.grapeVariety.id] =
                        1 + (counts[e.grapeVariety.id] || 0);

                      rows[e.vineyardRow.id] = 1 + (rows[e.vineyardRow.id] || 0);
                      // rows[e.id] = 1 + (rows[e.id] || 0);
                    }
                  );

                  _this.broj_sorti = Object.keys(counts).length;
                  _this.broj_redova = Object.keys(rows).length;

                  _this.povrsina =
                    Math.round(_this.objVineyardPlaint.surface * 100) / 100;

                  this.objVineyardOperationRows =
                    response.data.vineyardOperationRows;

                  this.objVineyardOperationBlock =
                    response.data.vineyardOperationBlocks;

                  this.objVineyardOperationTables =
                    response.data.vineyardOperationTables;

                  let pomObjVineyardOperationExecution = {
                    id: null,
                    vineyardOperation: {
                      id: null,
                    },
                    vineyard: {
                      id: null,
                    },
                    date: null,
                    dateTo: null,
                    vineyardOperationWorkForces: [],
                    vineyardOperationMechanizations: [],
                    vineyardOperationMaterials: [],
                    vineyardOperationRows: response.data.vineyardOperationRows,
                    description: null,
                    phenoPhase: null,
                    vineyardOperationBlocks:
                      response.data.vineyardOperationBlocks,
                    vineyardOperationTables:
                      response.data.vineyardOperationTables,
                  };

                  pomObjVineyardOperationExecution.id = response.data.id;
                  pomObjVineyardOperationExecution.vineyardOperation = {
                    id: response.data.vineyardOperation.id,
                  };
                  pomObjVineyardOperationExecution.vineyard = {
                    id: response.data.vineyard.id,
                  };
                  pomObjVineyardOperationExecution.date = response.data.date;
                  pomObjVineyardOperationExecution.dateTo =
                    response.data.dateTo;
                  pomObjVineyardOperationExecution.surface =
                    response.data.surface;
                  pomObjVineyardOperationExecution.phenoPhase =
                    response.data.phenoPhase;

                  pomObjVineyardOperationExecution.description =
                    response.data.description;

                  this.objVineyardOperationExecution = {
                    ...pomObjVineyardOperationExecution,
                  };
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaKalem2(broj) {
      let tekst = "";

      if (this.vinarija){
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      }
      else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";        
      };

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    submit() {
        if(this.id_vineyard === undefined || this.id_vineyard === null){
          alert("Snimanje nije izvršeno, nije izabran vinograd.");

          const childElement = document.getElementById("closeModalMagacinBtn");  
          console.log(childElement)  
          childElement.click();

          this.$router.push({name: "vineyards"});
        }
        else if (this.$refs.form1.validate()) {
        if (this.ID != "" && this.ID != 0) this.changeSifarnik();
        else this.newSifarnik();
      }
    },
    clear() {
      this.objVineyardOperationRows = [];
      
      this.ID_grape_variety = 0;
      this.ID_reda = 0;

      this.$refs.form.reset();

      if (this.ID > 0) this.getAllSifarnikInit(this.ID);
      else {
        this.setTime();
        this.setDate();
      }

      this.sufiks = "";
    },
  },
  mounted() {
    this.vinarija = daLiJeVinarija();

    if(this.vinarija)
      this.tekstBiljka = "Broj čokota";
    else
      this.tekstBiljka = "Broj biljaka";

    this.clear();

    this.getAllPhenoPhase();

    serverBus.$on("vy_condition", (id_vinograda, item) => {
      if (item !== null) {
        if (item.edit !== undefined && item.edit !== null)
          this.izmena = item.edit;
        else this.izmena = true;
      } else this.izmena = true;

      if (id_vinograda !== 0 && id_vinograda !== "0")
        this.id_vineyard = id_vinograda;
      else this.id_vineyard = undefined;

      console.log(this.ID_grape_variety);
      if (item !== null) {
        this.ID = item.id;
        this.getAllSifarnikInit(item.id);
      }
    });
  },
  beforeMount() {
    
  }
};
</script>


<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

div.v-subheader {
  padding-top: 20px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin: 0px;
}

#HeaderRow {
  font-size: 18px;
  color: #6d001a;
  padding-left: 15px;
}
@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

#FloatingButton {
  // position: absolute;
  width: 48px;
  height: 48px;
  font-size: 25px;
  border-radius: 50%;

  background-color: #018389;
  background-image: url("../assets/menuIcons/vinograd.svg");
  background-position: center;

  &:active,
  &:focus {
    box-shadow: none;
  }
}

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
.div_prozorce {
  border-color: white !important;
  border-style: solid !important;
  height: 100% !important;
  border-radius: 15px !important;
}

.gornji_text {
  font-size: 18px !important;
  margin: 0px !important;
  padding-top: 10px !important;
  text-align: center;
}

.donji_text {
  font-size: 12px !important;
  text-align: center;
  margin: 0px !important;
  line-height: 0.1 !important;
}
</style>

